import { useAppInsightsContext, useTrackEvent } from '@microsoft/applicationinsights-react-js';
import { useSelector } from 'react-redux';

export const useAppInsightLog = () => {
	const appInsights = useAppInsightsContext();
	const trackEvent = useTrackEvent(appInsights, 'Generic Event', {});
	const userName = useSelector((state) => state?.sharedStates?.currentUser?.user?.userName);

	const logEvent = (properties) => {
		trackEvent({
			...properties,
			'User Identification': userName,
			'Event Source': 'Payroll Portal Application',
		});
		appInsights.core.flush();
	};

	return { logEvent };
};

export const useLogSsoError = () => {
	const { logEvent } = useAppInsightLog();
	const logSsoError = (actionTaken, error) => {
		const errorProps = {
			'Event Type': 'SSO Error',
			'Action Taken': actionTaken,
			Details: `SSO Error :: ${JSON.stringify(error)}`,
		};
		logEvent(errorProps);
	};

	return logSsoError;
};
